import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  newEventButton: {
    transform: 'scale(1.5)',
  },
});
